// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "block-QiwOv";
var _4 = "passengers-2rTrA";
var _5 = "passengers_readonly-15V7Z";
export { _1 as "__esModule", _2 as "mobile", _3 as "block", _4 as "passengers", _5 as "passengers_readonly" }
export default { "__esModule": _1, "mobile": _2, "block": _3, "passengers": _4, "passengers_readonly": _5 }
